<script>
import { ContentLoader } from 'vue-content-loader';

export default {
  components: { ContentLoader },
};
</script>

<template>
  <content-loader
    width="1276"
    height="945"
    viewBox="0 0 1276 945"
    :speed="2"
    primaryColor="#F9FAFF"
    secondaryColor="#D8DFF6"
    :primaryOpacity="0.9"
    :secondaryOpacity="0.25"
  >
    <rect x="144" y="890" width="776" height="20" rx="4" />
    <rect x="975" y="890" width="220" height="20" rx="4" />
    <circle cx="103" cy="900" r="23" />
    <rect x="144" y="795" width="776" height="20" rx="4" />
    <rect x="975" y="795" width="220" height="20" rx="4" />
    <circle cx="103" cy="805" r="23" />
    <rect x="144" y="700" width="776" height="20" rx="4" />
    <rect x="975" y="700" width="220" height="20" rx="4" />
    <circle cx="103" cy="710" r="23" />
    <rect x="144" y="605" width="776" height="20" rx="4" />
    <rect x="975" y="605" width="220" height="20" rx="4" />
    <circle cx="103" cy="615" r="23" />
    <rect x="144" y="510" width="776" height="20" rx="4" />
    <rect x="975" y="510" width="220" height="20" rx="4" />
    <circle cx="103" cy="520" r="23" />
    <rect x="144" y="415" width="776" height="20" rx="4" />
    <rect x="975" y="415" width="220" height="20" rx="4" />
    <circle cx="103" cy="425" r="23" />
    <rect x="144" y="320" width="776" height="20" rx="4" />
    <rect x="975" y="320" width="220" height="20" rx="4" />
    <circle cx="103" cy="330" r="23" />
    <rect x="144" y="225" width="776" height="20" rx="4" />
    <rect x="975" y="225" width="220" height="20" rx="4" />
    <circle cx="103" cy="235" r="23" />
    <rect x="144" y="130" width="776" height="20" rx="4" />
    <rect x="975" y="130" width="220" height="20" rx="4" />
    <circle cx="103" cy="140" r="23" />
    <rect x="144" y="35" width="776" height="20" rx="4" />
    <rect x="975" y="35" width="220" height="20" rx="4" />
    <circle cx="103" cy="45" r="23" />
  </content-loader>
</template>
